import type { SupportedLocale } from '@viamichelin/business';

interface ContactUrlGroup {
	locales: SupportedLocale[];
	url: string;
}

const CONTACT_URL_GROUPS: ContactUrlGroup[] = [
	{
		locales: ['fr-FR', 'fr-BE', 'fr-CH'],
		url: 'https://intercom.help/viamichelin/fr',
	},
	{
		locales: ['en-GB', 'en-IE', 'en-US', 'de-AT', 'de-CH', 'de-DE', 'nl-BE', 'nl-NL', 'pt-PT'],
		url: 'https://intercom.help/viamichelin/en/',
	},
	{
		locales: ['es-ES'],
		url: 'https://intercom.help/viamichelin/es/',
	},
	{
		locales: ['it-CH', 'it-IT'],
		url: 'https://intercom.help/viamichelin/it/',
	},
];

function createContactLinkMap() {
	const result = {} as Record<SupportedLocale, string>;

	for (const group of CONTACT_URL_GROUPS) {
		for (const locale of group.locales) {
			result[locale] = group.url;
		}
	}

	return result;
}

export const contactLinkPerLocale = createContactLinkMap() satisfies Record<SupportedLocale, string>;
